export type XMarkIconProps = React.SVGProps<SVGSVGElement> & {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
};

export const XMarkIcon = ({ width = 17, height = 17, style, ...attrs }: XMarkIconProps) => {
  return (
    <svg
      style={style}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...attrs}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.9024 3.56904C13.0325 3.43886 13.0325 3.22781 12.9024 3.09763C12.7722 2.96746 12.5611 2.96746 12.431 3.09763L8 7.5286L3.56904 3.09763C3.43886 2.96746 3.22781 2.96746 3.09763 3.09763C2.96746 3.22781 2.96746 3.43886 3.09763 3.56904L7.5286 8L3.09763 12.431C2.96746 12.5611 2.96746 12.7722 3.09763 12.9024C3.22781 13.0325 3.43886 13.0325 3.56904 12.9024L8 8.47141L12.431 12.9024C12.5611 13.0325 12.7722 13.0325 12.9024 12.9024C13.0325 12.7722 13.0325 12.5611 12.9024 12.431L8.47141 8L12.9024 3.56904Z'
        fill='#222222'
      />
    </svg>
  );
};
